import { Injectable, Directive, ElementRef, Renderer2, HostBinding, Input, NgModule, Component, ChangeDetectorRef, ViewChild, ContentChild, TemplateRef, Inject } from '@angular/core';
import { Str } from '@wke/ucc-angular-alt-common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { IconModule } from '@wke/ucc-icons';
import { BLOCKUI_PARAMS } from '@wke/ucc-angular-alt-overlay';

/**
 * Este servicio proporciona métodos que ayudan al usuario sobre la carga de imagenes en la aplicación, como por ejemplo el
 * poder transformar Blobs en imagenes o la descarga de éstas
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@angular/common';

const _c0 = ["container"];
const _c1 = function (a0) { return { badgeContentText: a0 }; };
function BadgeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2, 3);
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("top", ctx_r0.top, "px")("left", ctx_r0.left, "px")("width", ctx_r0.width, "px")("height", ctx_r0.height, "px")("min-width", ctx_r0.minWidth, "px")("min-height", ctx_r0.minHeight, "px")("background-color", ctx_r0.color);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c1, ctx_r0.hasContent()));
} }
const _c2 = ["*"];
const _c3 = ["template"];
class ImageLoaderService {
    /** @ignore */
    constructor(_sanatizer, _httpClient) {
        this._sanatizer = _sanatizer;
        this._httpClient = _httpClient;
    }
    /**
     * Este método transforma un Blob en una SafeUrl para poder usarla como imagen en la aplicacion
     * @param imageBlob
     */
    convertFromBlob(imageBlob) {
        return this._sanatizer.bypassSecurityTrustUrl(URL.createObjectURL(imageBlob));
    }
    /**
     * Este método transforma un Blob en un SafeStyle para poder usarla como imagen de fondo en la aplicacion
     * @param imageBlob
     */
    convertFromBlobToBackgroundImage(imageBlob) {
        return this._sanatizer.bypassSecurityTrustStyle(`url('${URL.createObjectURL(imageBlob)}')`);
    }
    /**
     * Este método devuelve una promesa con un Blob, el cual es la imagen descargada
     * @param url
     */
    downloadImage(url) {
        return this._httpClient.get(url, { responseType: "blob" }).toPromise();
    }
}
ImageLoaderService.ɵfac = function ImageLoaderService_Factory(t) { return new (t || ImageLoaderService)(ɵngcc0.ɵɵinject(ɵngcc1.DomSanitizer), ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
ImageLoaderService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ImageLoaderService, factory: ImageLoaderService.ɵfac });
/** @nocollapse */
ImageLoaderService.ctorParameters = () => [
    { type: DomSanitizer },
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageLoaderService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DomSanitizer }, { type: ɵngcc2.HttpClient }]; }, null); })();

/**
 * Esta directiva se utiliza para la insertar una imagen en el elemento HTML donde se haya declarado, con una forma opcional
 * definida a partir del tipo [ImageShapeKinds]{@link ImageShapeKinds}.
 *
 * @example
 * <div [ngwkImage]="imageUrl" imageShape="circular"></div>
 */
class NgwkImageDirective {
    /** @ignore */
    constructor(_el, _renderer, _imageLoader) {
        this._el = _el;
        this._renderer = _renderer;
        this._imageLoader = _imageLoader;
    }
    /** @ignore */
    get background() {
        return this._background;
    }
    setImageShape(shape) {
        let imageClass = null;
        switch (shape) {
            case 'circular': {
                imageClass = 'wrapperCircularImage';
                break;
            }
            case 'rectangular': {
                imageClass = 'wrapperRectangleImage';
                break;
            }
        }
        if (imageClass) {
            this._renderer.addClass(this._el.nativeElement, imageClass);
        }
    }
    setBackgroundImage(value) {
        if (value instanceof Blob) {
            this.setBlobAsBackgroundImage(value);
        }
        else if (Str.isString(value)) {
            this._imageLoader.downloadImage(value).then((imgBlob) => this.setBlobAsBackgroundImage(imgBlob));
        }
        else {
            console.error(`Error on ImageDirective.Image. Image isn't a Blob or String`, value, this);
        }
    }
    setBlobAsBackgroundImage(imgBlob) {
        this._background = this._imageLoader.convertFromBlobToBackgroundImage(imgBlob);
    }
    /**
     * Permite definir la imagen que aparecerá en el elemento HTML donde esté declarado en forma de background
     *
     * @param value Imagen que aparecerá en el elemento HTML en forma de background
     */
    set ngwkImage(value) {
        this.setBackgroundImage(value);
    }
    /**
     * Permite definir la forma de la imagen que aparecerá en el elemento HTML. Los tipos de forma están definidos en
     * [ImageShapeKinds]{@link ImageShapeKinds}
     *
     * @param value Forma de la imagen de tipo. [ImageShapeKinds]{@link ImageShapeKinds}
     */
    set imageShape(value) {
        this.setImageShape(value);
    }
}
NgwkImageDirective.ɵfac = function NgwkImageDirective_Factory(t) { return new (t || NgwkImageDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ImageLoaderService)); };
NgwkImageDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgwkImageDirective, selectors: [["", "ngwkImage", ""]], hostVars: 2, hostBindings: function NgwkImageDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("background-image", ctx.background);
    } }, inputs: { ngwkImage: "ngwkImage", imageShape: "imageShape" } });
/** @nocollapse */
NgwkImageDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ImageLoaderService }
];
NgwkImageDirective.propDecorators = {
    background: [{ type: HostBinding, args: ['style.background-image',] }],
    ngwkImage: [{ type: Input }],
    imageShape: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgwkImageDirective, [{
        type: Directive,
        args: [{
                selector: '[ngwkImage]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ImageLoaderService }]; }, { background: [{
            type: HostBinding,
            args: ['style.background-image']
        }], ngwkImage: [{
            type: Input
        }], imageShape: [{
            type: Input
        }] }); })();

class ImageModule {
}
ImageModule.ɵfac = function ImageModule_Factory(t) { return new (t || ImageModule)(); };
ImageModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ImageModule });
ImageModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageModule, [{
        type: NgModule,
        args: [{
                exports: [NgwkImageDirective],
                declarations: [NgwkImageDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ImageModule, { declarations: [NgwkImageDirective], exports: [NgwkImageDirective] }); })();

/**
 * Componente que representa un punto del color especificado, y tiene como objetivo notificar al usuario de que ha habido cambios/novedades, allí donde se muestra.
 * @example
 * <ngwk-badge [show]="showBadge"
 *    [top]="badgeTop"
 *    [left]="badgeLeft"
 *    [color]="badgeColor">
 * </ngwk-badge>
 */
class BadgeComponent {
    /** @ignore */
    constructor(_cdr) {
        this._cdr = _cdr;
        /** Permite activar o desactivar el estado de visible del Badge */
        this.show = false;
        /** Permite posicionar verticalmente donde mostrar el Badge */
        this.top = 0;
        /** Permite posicionar horizontalmente donde mostrar el Badge */
        this.left = 0;
        /** Permite asignar el color del Badge */
        this.color = null;
        /** Permite asignar el height total del componente Badge */
        this.height = null;
        /** Permite asignar el width total del componente Badge */
        this.width = null;
        /** Permite asignar el height mínimo del componente Badge. De manera predeterminada es 10px */
        this.minHeight = 10;
        /** Permite asignar el width mínimo del componente Badge. De manera predeterminada es 10px */
        this.minWidth = 10;
    }
    /** @ignore */
    ngAfterViewChecked() {
        this._cdr.detectChanges();
    }
    /** @ignore */
    hasContent() {
        return this._container ? this._container.nativeElement.childNodes.length > 0 : false;
    }
}
BadgeComponent.ɵfac = function BadgeComponent_Factory(t) { return new (t || BadgeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BadgeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BadgeComponent, selectors: [["ngwk-badge"]], viewQuery: function BadgeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._container = _t.first);
    } }, inputs: { show: "show", top: "top", left: "left", color: "color", height: "height", width: "width", minHeight: "minHeight", minWidth: "minWidth" }, ngContentSelectors: _c2, decls: 1, vars: 1, consts: [["class", "badgeContent", 3, "top", "left", "width", "height", "min-width", "min-height", "background-color", 4, "ngIf"], [1, "badgeContent"], [3, "ngClass"], ["container", ""]], template: function BadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BadgeComponent_div_0_Template, 4, 17, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass], styles: [".badgeContent[_ngcontent-%COMP%]{position:absolute;border-radius:25px;max-width:42px;background-color:#f37911}.badgeContentText[_ngcontent-%COMP%]{font-size:11px;color:#fff;padding:0 5px}"] });
/** @nocollapse */
BadgeComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
BadgeComponent.propDecorators = {
    show: [{ type: Input }],
    top: [{ type: Input }],
    left: [{ type: Input }],
    color: [{ type: Input }],
    height: [{ type: Input }],
    width: [{ type: Input }],
    minHeight: [{ type: Input }],
    minWidth: [{ type: Input }],
    _container: [{ type: ViewChild, args: ['container',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-badge',
                template: "<div class=\"badgeContent\"\r\n     *ngIf=\"show\"\r\n     [style.top.px]=\"top\"\r\n     [style.left.px]=\"left\"\r\n     [style.width.px]=\"width\"\r\n     [style.height.px]=\"height\"\r\n     [style.min-width.px]=\"minWidth\"\r\n     [style.min-height.px]=\"minHeight\"\r\n     [style.background-color]=\"color\">\r\n     <div #container [ngClass]=\"{ badgeContentText : hasContent() }\">\r\n         <ng-content></ng-content>\r\n     </div>\r\n</div>",
                styles: [".badgeContent{position:absolute;border-radius:25px;max-width:42px;background-color:#f37911}.badgeContentText{font-size:11px;color:#fff;padding:0 5px}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { show: [{
            type: Input
        }], top: [{
            type: Input
        }], left: [{
            type: Input
        }], color: [{
            type: Input
        }], height: [{
            type: Input
        }], width: [{
            type: Input
        }], minHeight: [{
            type: Input
        }], minWidth: [{
            type: Input
        }], _container: [{
            type: ViewChild,
            args: ['container']
        }] }); })();

class BadgeModule {
}
BadgeModule.ɵfac = function BadgeModule_Factory(t) { return new (t || BadgeModule)(); };
BadgeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BadgeModule });
BadgeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BadgeModule, [{
        type: NgModule,
        args: [{
                exports: [BadgeComponent],
                declarations: [BadgeComponent],
                imports: [CommonModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BadgeModule, { declarations: function () { return [BadgeComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BadgeComponent]; } }); })();

/**
 * Este componente se utiliza como base para el resto de componentes de tipo Card.
 *
 * @example
 * <ngwk-base-card [id]="id" [displayMode]="displayMode">
 *      Content
 * </ngwk-base-card>
 *
 */
class BaseCardComponent {
    constructor() {
        this._displayMode = 'triple';
        this._id = null;
    }
    /**
     * Método que devuelve la clase aplicada a la Card, la cual es determinada por el atributo 'displayMode'.
     */
    getClass() {
        if (this.displayMode === 'triple') {
            return 'cardsWidgetTriple';
        }
        else {
            return 'cardsWidgetQuadruple';
        }
    }
    /**
     * Permite obtener el id del Card
     */
    get id() {
        return this._id;
    }
    /**
     * Permite definir el id del Card
     *
     * @param value El id del Card
     */
    set id(value) {
        this._id = value;
    }
    /**
     * Permite obtener el modo en el que se muestra la Card, el cual es de tipo [CardDisplayMode]{@link CardDisplayMode}
     */
    get displayMode() {
        return this._displayMode;
    }
    /**
     * Permite definir el modo en el que se muestra la Card, el cual es de tipo [CardDisplayMode]{@link CardDisplayMode}
     *
     * @param value El modo en el que se muestra la Card
     */
    set displayMode(value) {
        this._displayMode = value;
    }
    /**
     * Permite obtener la template que contiene la Card como contenido
     */
    get template() {
        return this._template;
    }
}
BaseCardComponent.ɵfac = function BaseCardComponent_Factory(t) { return new (t || BaseCardComponent)(); };
BaseCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BaseCardComponent, selectors: [["ngwk-base-card"]], contentQueries: function BaseCardComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c3, 7, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._template = _t.first);
    } }, inputs: { id: "id", displayMode: "displayMode" }, ngContentSelectors: _c2, decls: 2, vars: 2, consts: [[1, "verticalLayout", 3, "id", "ngClass"]], template: function BaseCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.id);
        ɵngcc0.ɵɵproperty("ngClass", ctx.getClass());
    } }, directives: [ɵngcc3.NgClass], styles: ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .cardsWidgetTriple[_ngcontent-%COMP%]{background-color:#f8fafb;padding:7px 20px 3px;border-radius:2px;height:86px;margin-bottom:10px}[_nghost-%COMP%]   .cardsWidgetQuadruple[_ngcontent-%COMP%]{background-color:#f8fafb;padding:7px 20px 3px;border-radius:2px;height:58px;margin-bottom:15px}"] });
BaseCardComponent.propDecorators = {
    _template: [{ type: ContentChild, args: ['template', { read: TemplateRef, static: true },] }],
    id: [{ type: Input }],
    displayMode: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseCardComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-base-card',
                template: "<div id=\"{{id}}\" class=\"verticalLayout\" [ngClass]=\"getClass()\">\r\n    <ng-content></ng-content>\r\n</div>\r\n",
                styles: [":host{width:100%}:host .cardsWidgetTriple{background-color:#f8fafb;padding:7px 20px 3px;border-radius:2px;height:86px;margin-bottom:10px}:host .cardsWidgetQuadruple{background-color:#f8fafb;padding:7px 20px 3px;border-radius:2px;height:58px;margin-bottom:15px}\n"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], displayMode: [{
            type: Input
        }], _template: [{
            type: ContentChild,
            args: ['template', { read: TemplateRef, static: true }]
        }] }); })();

/**
 *  Este componente se utiliza para la declaración de una [BaseCardComponent]{@link BaseCardComponent} de tipo SituationCard
 *
 *  @example
 *  <ngwk-situation-card [id]="id" [displayMode]="displayMode" [cardTitle]="cardTitle" [quantity]="quantity">
 *      Content
 *  </ngwk-situation-card>
 */
class SituationCardComponent {
    /** @ignore */
    constructor() {
        this._cardTitle = null;
        this._quantity = null;
        this._displayMode = 'triple';
    }
    ngOnInit() { }
    /**
     * Permite obtener el cardTitle del Situation Card
     */
    get cardTitle() {
        return this._cardTitle;
    }
    /**
     * Permite definir el cardTitle del Situation Card
     *
     * @param value El cardTitle del Situation Card
     */
    set cardTitle(value) {
        this._cardTitle = value;
    }
    /**
     * Permite obtener el quantity del Situation Card. Aun siendo un string, representa una cantidad numérica formateada.
     */
    get quantity() {
        return this._quantity;
    }
    /**
     * Permite definir el quantity del Situation Card. Aun siendo un string, representa una cantidad numérica formateada.
     *
     * @param value El quantity del Situation Card
     */
    set quantity(value) {
        this._quantity = value;
    }
    /**
     * Permite obtener el modo en el que se muestra la Situation Card, el cual es de tipo [CardDisplayMode]{@link CardDisplayMode}
     */
    get displayMode() {
        return this._displayMode;
    }
    /**
     * Permite definir el modo en el que se muestra la Situation Card, el cual es de tipo [CardDisplayMode]{@link CardDisplayMode}
     *
     * @param value El modo en el que se muestra la Situation Card
     */
    set displayMode(value) {
        this._displayMode = value;
    }
}
SituationCardComponent.ɵfac = function SituationCardComponent_Factory(t) { return new (t || SituationCardComponent)(); };
SituationCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SituationCardComponent, selectors: [["ngwk-situation-card"]], inputs: { cardTitle: "cardTitle", quantity: "quantity", displayMode: "displayMode" }, ngContentSelectors: _c2, decls: 8, vars: 3, consts: [[1, "verticalLayout", 3, "displayMode"], [1, "rowAuto", "situationCardTitle"], [1, "cardBoxSituation", "horizontalLayout", "rowAvailable", "alignVerticalMiddle"], [1, "colAvailable"], [1, "colAvailable", "situationCardTotal", 2, "text-align", "right"]], template: function SituationCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ngwk-base-card", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("displayMode", ctx.displayMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.cardTitle, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.quantity, " ");
    } }, directives: [BaseCardComponent], styles: ["[_nghost-%COMP%]   .cardBoxSituation[_ngcontent-%COMP%]{display:flex;margin-top:7px;line-height:24px}[_nghost-%COMP%]   .situationCardTitle[_ngcontent-%COMP%]{color:#aaa;font-size:12px;line-height:12px}[_nghost-%COMP%]   .situationCardTotal[_ngcontent-%COMP%]{font-size:20px;color:#6e6e6e}"] });
/** @nocollapse */
SituationCardComponent.ctorParameters = () => [];
SituationCardComponent.propDecorators = {
    cardTitle: [{ type: Input }],
    quantity: [{ type: Input }],
    displayMode: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SituationCardComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-situation-card',
                template: "<ngwk-base-card [displayMode]=\"displayMode\" class=\"verticalLayout\">\r\n    <div class=\"rowAuto situationCardTitle\">\r\n        {{cardTitle}}\r\n    </div>\r\n\t<div class=\"cardBoxSituation horizontalLayout rowAvailable alignVerticalMiddle\">\r\n\t\t<div class=\"colAvailable\">\r\n\t\t\t<ng-content></ng-content>\r\n\t\t</div>\r\n\t\t<div style=\"text-align: right;\" class=\"colAvailable situationCardTotal\">\r\n\t\t\t{{quantity}}\r\n\t\t</div>\r\n\t</div>\r\n</ngwk-base-card>\r\n",
                styles: [":host .cardBoxSituation{display:flex;margin-top:7px;line-height:24px}:host .situationCardTitle{color:#aaa;font-size:12px;line-height:12px}:host .situationCardTotal{font-size:20px;color:#6e6e6e}\n"]
            }]
    }], function () { return []; }, { cardTitle: [{
            type: Input
        }], quantity: [{
            type: Input
        }], displayMode: [{
            type: Input
        }] }); })();

class CardsModule {
}
CardsModule.ɵfac = function CardsModule_Factory(t) { return new (t || CardsModule)(); };
CardsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CardsModule });
CardsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BaseCardComponent,
                    SituationCardComponent
                ],
                exports: [
                    SituationCardComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CardsModule, { declarations: function () { return [BaseCardComponent, SituationCardComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SituationCardComponent]; } }); })();

/**
 * Este componente sirve para declarar una vista de cargando datos
 *
 * @example
 * <ngwk-loading-data [color]="color" [size]="size"></ngwk-loading-data>
 */
class LoadingDataComponent {
    /** Ignore */
    constructor() {
        this._color = "#474747";
        this._size = 70;
    }
    /** Ignore */
    agInit(params) { }
    /**
     * Permite obtener el color del elemento de carga de datos
     */
    get color() {
        return this._color;
    }
    /**
     * Permite definir el color del elemento de carga de datos
     *
     * @param value El color del elemento de carga de datos
     */
    set color(value) {
        this._color = value;
    }
    /**
     * Permite obtener el tamaño del elemento de carga de datos
     */
    get size() {
        return this._size;
    }
    /**
     * Permite definir el tamaño del elemento de carga de datos
     *
     * @param value El tamaño del elemento de carga de datos
     */
    set size(value) {
        this._size = value;
    }
}
LoadingDataComponent.ɵfac = function LoadingDataComponent_Factory(t) { return new (t || LoadingDataComponent)(); };
LoadingDataComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoadingDataComponent, selectors: [["ngwk-loading-data"]], inputs: { color: "color", size: "size" }, decls: 2, vars: 4, consts: [[1, "alignMiddle", 2, "width", "100%", "height", "100%"], [1, "k-i-loading"]], template: function LoadingDataComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("color", ctx.color)("font-size", ctx.size, "px");
    } }, styles: [".k-i-loading[_ngcontent-%COMP%]:before, .k-loading-image[_ngcontent-%COMP%]:before{animation:k-loading-animation 1.2s linear infinite;border-width:2px}.k-i-loading[_ngcontent-%COMP%]:after, .k-loading-image[_ngcontent-%COMP%]:after{border-width:2px}"] });
/** @nocollapse */
LoadingDataComponent.ctorParameters = () => [];
LoadingDataComponent.propDecorators = {
    color: [{ type: Input }],
    size: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingDataComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-loading-data',
                template: "<div style=\"width:100%;height:100%;\" class=\"alignMiddle\">\r\n  <span class=\"k-i-loading\" [style.color]=\"color\" [style.font-size.px]=\"size\"></span>\r\n</div>\r\n",
                styles: [".k-i-loading:before,.k-loading-image:before{animation:k-loading-animation 1.2s linear infinite;border-width:2px}.k-i-loading:after,.k-loading-image:after{border-width:2px}\n"]
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();

class LoadingDataModule {
}
LoadingDataModule.ɵfac = function LoadingDataModule_Factory(t) { return new (t || LoadingDataModule)(); };
LoadingDataModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LoadingDataModule });
LoadingDataModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingDataModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    LoadingDataComponent
                ],
                exports: [
                    LoadingDataComponent
                ],
                entryComponents: [LoadingDataComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoadingDataModule, { declarations: function () { return [LoadingDataComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LoadingDataComponent]; } }); })();

/**
 * Este componente se a través del BlockUIService, declarandolo directamente con su configuración, la cual únicamente es un data con
 * un texto
 *
 * @example
 *  const busyIndicatorConfig: NgwkBlockUIConfig<string> = {
 *    backdropClass: 'block-ui',
 *    data: 'Estamos cargando los datos de tu empresa.'
 *  };
 *  const busyIndicatorRef = this._blockUIService.show(BusyIndicatorComponent, busyIndicatorConfig);
 *  ...
 *  busyIndicatorRef.close();
 *
 */
class BusyIndicatorComponent {
    /** @ignore */
    constructor(_blockUIParams) {
        this._blockUIParams = _blockUIParams;
    }
    ngOnInit() {
        this._text = this._blockUIParams.data;
    }
    /** @ignore */
    get text() {
        return this._text;
    }
}
BusyIndicatorComponent.ɵfac = function BusyIndicatorComponent_Factory(t) { return new (t || BusyIndicatorComponent)(ɵngcc0.ɵɵdirectiveInject(BLOCKUI_PARAMS)); };
BusyIndicatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BusyIndicatorComponent, selectors: [["ngwk-busy-indicator"]], decls: 7, vars: 1, consts: [[1, "strechContainerCompany"], [1, "titleLoadingCompany"], [1, "spinner"], [1, "bounce1"], [1, "bounce2"], [1, "bounce3"]], template: function BusyIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelement(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.text);
    } }, styles: [".titleLoadingCompany[_ngcontent-%COMP%]{font-size:25px;color:#373737;text-align:center}.spinner[_ngcontent-%COMP%]{margin:50px auto 0;width:90px;text-align:center}.spinner[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:18px;height:18px;margin:0 4px;background-color:#0081c6;border-radius:100%;display:inline-block;animation:sk-bouncedelay 1.4s infinite ease-in-out both}.spinner[_ngcontent-%COMP%]   .bounce1[_ngcontent-%COMP%]{animation-delay:-.32s}.spinner[_ngcontent-%COMP%]   .bounce2[_ngcontent-%COMP%]{animation-delay:-.16s}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}"] });
/** @nocollapse */
BusyIndicatorComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BLOCKUI_PARAMS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BusyIndicatorComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-busy-indicator',
                template: "<div class=\"strechContainerCompany\">\r\n    <div class=\"titleLoadingCompany\">{{text}}</div>\r\n    <div class=\"spinner\">\r\n        <div class=\"bounce1\"></div>\r\n        <div class=\"bounce2\"></div>\r\n        <div class=\"bounce3\"></div>\r\n      </div>\r\n</div>",
                styles: [".titleLoadingCompany{font-size:25px;color:#373737;text-align:center}.spinner{margin:50px auto 0;width:90px;text-align:center}.spinner>div{width:18px;height:18px;margin:0 4px;background-color:#0081c6;border-radius:100%;display:inline-block;animation:sk-bouncedelay 1.4s infinite ease-in-out both}.spinner .bounce1{animation-delay:-.32s}.spinner .bounce2{animation-delay:-.16s}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}\n"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BLOCKUI_PARAMS]
            }] }]; }, null); })();

class BusyIndicatorModule {
}
BusyIndicatorModule.ɵfac = function BusyIndicatorModule_Factory(t) { return new (t || BusyIndicatorModule)(); };
BusyIndicatorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BusyIndicatorModule });
BusyIndicatorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BusyIndicatorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule
                ],
                declarations: [
                    BusyIndicatorComponent
                ],
                exports: [
                    BusyIndicatorComponent
                ],
                entryComponents: [BusyIndicatorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BusyIndicatorModule, { declarations: function () { return [BusyIndicatorComponent]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [BusyIndicatorComponent]; } }); })();

class DrawingModule {
}
DrawingModule.ɵfac = function DrawingModule_Factory(t) { return new (t || DrawingModule)(); };
DrawingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DrawingModule });
DrawingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        ImageLoaderService
    ], imports: [[
            ImageModule,
            BadgeModule,
            CardsModule,
            LoadingDataModule,
            BusyIndicatorModule
        ], ImageModule, BadgeModule, CardsModule, LoadingDataModule, BusyIndicatorModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DrawingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ImageModule,
                    BadgeModule,
                    CardsModule,
                    LoadingDataModule,
                    BusyIndicatorModule
                ],
                exports: [
                    ImageModule,
                    BadgeModule,
                    CardsModule,
                    LoadingDataModule,
                    BusyIndicatorModule
                ],
                providers: [
                    ImageLoaderService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DrawingModule, { imports: [ImageModule, BadgeModule, CardsModule, LoadingDataModule, BusyIndicatorModule], exports: [ImageModule, BadgeModule, CardsModule, LoadingDataModule, BusyIndicatorModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeComponent, BadgeModule, BusyIndicatorComponent, BusyIndicatorModule, CardsModule, DrawingModule, ImageLoaderService, ImageModule, LoadingDataComponent, LoadingDataModule, NgwkImageDirective, SituationCardComponent, BaseCardComponent as ɵa };

